<template>
  <div class="app-container">
    <el-card shadow="never">
      <div slot="header" class="header">
        <span>复制广告</span>
        <span>广告主：《{{ this.$route.query.account_name }}》&nbsp;&nbsp;<span>服务商：{{ this.$route.query.service_name }}</span></span>
      </div>
      <div class="top">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-input
              v-model.trim="adqAdvertListParams.source_account_id"
              placeholder="请输入来源广告账户id"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model.trim="adqAdvertListParams.source_adgroup_id"
              placeholder="请输入来源广告组id"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model.trim="adqAdvertListParams.source_account_name"
              placeholder="请输入来源广告账户名称"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <el-button type="primary" @click="fetchAdqAdvertList">搜索</el-button>
          <el-button
            type="info"
            plain
            @click="resetTencentAdqAdverList"
          >重置</el-button>
          <el-button
            style="float: right"
            type="info"
            plain
            @click="stopAD"
          >停止广告复制</el-button>
          <!-- <el-button
            type="primary"
            @click="$refs.copyList.open()"
          >复制列表</el-button> -->
          <!-- <el-button
            v-if="adgroup_ids ? adgroup_ids.length : adgroup_ids"
            type="warning"
            @click="handleCopyTencentAdqAdver()"
          >批量复制</el-button> -->
        </el-row>
      </div>
      <div class="main">
        <el-table
          v-loading="loading"
          :data="adqAdvertList ? adqAdvertList : []"
          style="width: 100%"
          :row-class-name="'aaaa'"
          :row-key="getRowKeys"
          @select="multipleChoice"
          @select-all="multipleChoice"
        >
          <el-table-column prop="id" label="id" align="center" />
          <!-- <el-table-column
            prop="params"
            label="传入参数
"
            align="center"
            width="180"
          /> -->
          <el-table-column
            prop="source_account_id"
            label="来源广告账户id"
            align="center"
            width="180"
          />
          <el-table-column
            prop="source_account_name"
            label="来源广告账户名称"
            align="center"
            width="180"
          />
          <el-table-column
            prop="source_project_id"
            label="来源项目id"
            align="center"
            width="180"
          >
            <template scope="scope">
              {{ scope.row.source_project_id }}
            </template></el-table-column>
          <el-table-column
            prop="source_project_name"
            label="来源项目名称"
            align="center"
            width="180"
          />
          <el-table-column
            prop="target_account_id"
            label="目标广告账户id"
            align="center"
            width="180"
          />
          <el-table-column
            prop="target_account_name"
            label="目标广告账户名称"
            align="center"
            width="180"
          />
          <el-table-column
            prop="status"
            label="状态"
            align="center"
            width="180"
          >
            <template scope="scope">
              <div>
                <p class="overflow" :title="scope.row.status">
                  <span
                    :style="{
                      backgroundColor: getColorRgba(scope.row.status),
                      color: getColor(scope.row.status)
                    }"
                    class="account_status_text-dev"
                  >
                    {{
                      scope.row.status == 1
                        ? '完成'
                        : scope.row.status == 2
                          ? '终止'
                          : '待处理'
                    }}
                  </span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            align="center"
            width="180"
          />
          <!-- <el-table-column
            prop="params"
            label="传入参数"
            align="center"
            width="180"
          /> -->
          <el-table-column
            prop="copy_num"
            label="计划数量"
            align="center"
            width="180"
          />
          <el-table-column
            prop="success_num"
            label="成功数量"
            align="center"
            width="180"
          />

          <el-table-column
            prop="updated_at"
            label="更新时间"
            align="center"
            width="180"
          />
          <el-table-column prop="created_at" label="创建时间" align="center" />
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="200"
          >
            <template scope="scope">
              <el-button type="text" @click="linkskip(scope.row)">
                任务执行记录
              </el-button>
            </template>
          </el-table-column>

          <publicAdvertList ref="publicAdvertList" />
          <Copylist ref="copyList" />
          <CopyAdqAdDialog
            ref="copyAdqAdDialog"
            :adgroup_ids="adgroup_ids"
            @qindian="qindian"
            @guanbi="alone = null"
          />

          <!-- @pagination="fetchAdqAdvertList" -->
        </el-table>
        <PaginationRight
          :total="pageTotal"
          :page.sync="adqAdvertListParams.page"
          :limit.sync="adqAdvertListParams.page_size"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </div>
      <el-dialog title="分配账户" :visible.sync="dialogAccout" width="1000px">
        <dialogAccout ref="allocation" @callbackbacer="callbackbacer" />
      </el-dialog>
      <CopyMpAdDialog ref="copyMpAdDialog" @quedin="quedin" />
    </el-card>
  </div>
</template>

<script>
import CopyMpAdDialog from './CopyAdqAdDialog/index.vue'
import { copyJob_list } from '@/api/customer.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { copyAdqAdvert } from '@/api/customer/accountList/copyAdvertManage'
import { copyJob_stop } from '@/api/customer.js'

import publicAdvertList from '@/views/customer/accountList/tencentAdqAdvertManage/publicAdvertList'
import CopyAdqAdDialog from '@/views/customer/accountList/tencentAdqAdvertManage/CopyAdqAdvertManage/CopyAdqAdDialog/index.vue'
import Copylist from './Copylist/index.vue'
import dialogAccout from './components/dialogAccout.vue'

export default {
  name: 'CopyAdqAdvertManage',
  components: {
    PaginationRight,
    publicAdvertList,
    CopyAdqAdDialog,
    Copylist,
    CopyMpAdDialog,
    dialogAccout
  },
  data() {
    return {
      loading: false,
      pageTotal: 0,
      adqAdvertListParams: {
        source_adgroup_id: null, // 来源广告组id
        source_account_id:
          this.$route.query.item && this.$route.query.item.account_id
            ? this.$route.query.item.account_id
            : '', // 来源广告账户id
        source_account_name: null, // 来源广告账户名称
        page: 1,
        page_size: 10
      },
      adqAdvertList: null,
      adgroup_ids: null,
      alone: null,
      allow_template: null,
      adgroup_items: null,
      dialogAccout: false
    }
  },
  created() {
    // console.log(this.$route.query.item.account_id, '==')
    this.fetchAdqAdvertList()
    window.aaaaa = this
  },
  methods: {
    getColor(status) {
      const color = status === 1 ? '#22bf46' : '#ff8108'
      return color
    },
    getColorRgba(status) {
      const color =
        status === 1 ? 'rgba(34, 191, 70, 0.1)' : 'rgba(255, 213, 167, 0.1)'
      return color
    },
    stopAD() {
      this.dialogAccout = true
      this.$nextTick(() => {
        this.$refs.allocation.sendr()
      })
    },
    async callbackbacer(item, query) {
      console.log('item:', item)
      try {
        const res = await copyJob_stop(item)
        this.dialogAccout = false
        this.$message.success(res.message)
        this.fetchAdqAdvertList()
      } catch (error) {
        console.log('error:', error)
        this.$refs.allocation.sendr(query)
      }
    },
    fetchPageSize(e) {
      console.log('11', e)
      this.adqAdvertListParams.page_size = e
      this.fetchAdqAdvertList()
    },
    fetchCurrentPage(e) {
      console.log('22', e)
      this.adqAdvertListParams.page = e
      this.fetchAdqAdvertList()
    },
    async quedin(obj) {
      console.log('ob56565j:', obj)
      // console.log('res:', res)
      // this.$message.success(res.message)
      // this.fetchAdqAdvertList()
    },
    resrist() {
      console.log('清空')
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.viewbig.resback()
      }, 100)
    },

    linkskip(row) {
      this.$refs.copyMpAdDialog.open(row, 1)
      // this.$router.push({ path: '/tencentAD/copyRecord/job-record', query: { row: row }})
    },
    handleCopyMpAdvert(rowData) {
      console.log('rowData:', rowData)
      if (this.isFreshOk()) {
        this.$refs.copyMpAdDialog.open(rowData)
      }
    },
    confirm() {
      console.log('this.copyMpAdvertParams:', this.copyMpAdvertParams)
      this.handleCopyMpAdvert(this.copyMpAdvertParams)
    },
    // 获取广告列表
    fetchAdqAdvertList() {
      this.loading = true
      copyJob_list(this.adqAdvertListParams).then((res) => {
        console.log('res:', res)
        this.adqAdvertList = res.data.list
        // this.allow_template = res.data.allow_template
        // this.loadTheFirstPin(this.adqAdvertList)
        console.log(JSON.parse(res.data.list[0].params))
        this.pageTotal = res.data.total
        this.loading = false
      })
    },
    handleCopyTencentAdqAdver(rowData) {
      if (
        rowData &&
        !this.allow_template.includes(
          rowData.preview_info.adcreative_template_id
        )
      ) {
        return
      }
      if (!rowData) {
        const type = this.adgroup_items[0].promoted_object_type
        const newArr = this.adgroup_items.filter((item) => {
          return item.promoted_object_type === type
        })

        var text = null
        if (newArr.length !== this.adgroup_items.length) {
          text = '目标不一致'
        }
      }
      this.alone = rowData

      this.$refs.copyAdqAdDialog.open(
        text ||
          rowData || {
          promoted_object_type: this.adgroup_items[0].promoted_object_type
        }
      )
    },
    // 搜索公共广告
    searchTencentAdqAdver() {
      if (this.adqAdvertListParams.adgroup_name === '') {
        this.adqAdvertListParams.adgroup_name = null
      }
      this.adqAdvertListParams.page = 1
      this.fetchAdqAdvertList()
    },
    // 重置公共广告
    resetTencentAdqAdverList() {
      this.adqAdvertListParams = {
        source_adgroup_id: null, // 来源广告组id
        source_account_id: this.$route.query.account_id, // 来源广告账户id
        source_account_name: null, // 来源广告账户名称
        page: 1,
        page_size: 10
      }
      this.fetchAdqAdvertList()
    },
    multipleChoice(arr) {
      this.adgroup_ids = arr.map((item) => {
        return item.adgroup_id
      })
      this.adgroup_items = arr
    },
    async qindian(data1, func) {
      let obj = null
      // 判断是否不是批量复制
      if (this.alone) {
        obj = {
          origin: '2',
          account_id: this.$route.query.account_id,
          account_ids: data1,
          adgroup_ids: [this.alone.adgroup_id]
        }
      } else {
        obj = {
          origin: '2',
          account_id: this.$route.query.account_id,
          account_ids: data1,
          adgroup_ids: this.adgroup_ids
        }
      }
      copyAdqAdvert(obj)
        .then((data) => {
          this.$message({
            message: data.message,
            type: 'success'
          })
          func()
        })
        .catch((data) => {
          this.$message({
            message: `${data.message}`,
            type: 'error'
          })
        })
    },
    loadTheFirstPin(list) {
      for (let i = 0; i < list.length; i++) {
        if (!list[i].preview_info.img && list[i].preview_info.video) {
          diyi(list[i].preview_info, list[i].preview_info.video)
        }
      }

      const This = this

      function diyi(obj, src) {
        var videoElement = document.createElement('video')
        videoElement.src = src
        videoElement.addEventListener('canplay', function() {
          var canvas = document.createElement('canvas')
          canvas.width = videoElement.videoWidth
          canvas.height = videoElement.videoHeight
          canvas
            .getContext('2d')
            .drawImage(videoElement, 0, 0, canvas.width, canvas.height)
          var firstFrame = canvas.toDataURL('image/png') // 第一帧图片url
          This.$set(obj, 'firstStitch', firstFrame)
        })
      }
    },
    checkSelect(row, index) {
      return this.allow_template.includes(
        row.preview_info.adcreative_template_id
      )
    },
    getRowKeys(row) {
      return row.adgroup_id
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.main {
  margin-top: 20px;
  video {
    width: 100px;
    height: 100px;
    object-fit: fill;
  }
  .shadowBox {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
  }
}
.account_status_text-dev {
  // background-color: rgba(95, 252, 95, 0.1);
  padding: 12px;
  // color: #22bf46;
}
.titip {
  width: 154px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 这里是超出几行省略 */
  overflow: hidden;
}
</style>
